var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:[_vm.rootElementClass, _vm.componentStyle.container],attrs:{"type":"button"},on:{"click":_vm.startOver}},[_c('IconRestart')],1)}
var staticRenderFns = []

export { render, staticRenderFns }